<script>
export default {
  data() {
    return {};
  },
};
</script>

<template>
  <div class="card">
    <div class="card-body">
      <div class="d-flex">
        <div class="me-2">
          <h5 class="card-title mb-4">Atividade</h5>
        </div>
<!--        <b-dropdown-->
<!--          toggle-tag="a"-->
<!--          toggle-class="text-muted font-size-16 p-0"-->
<!--          variant="white"-->
<!--          menu-class="dropdown-menu-end"-->
<!--          right-->
<!--          class="ms-auto"-->
<!--        >-->
<!--          <template #button-content>-->
<!--            <i class="mdi mdi-dots-horizontal"></i>-->
<!--          </template>-->
<!--          <b-dropdown-item href="#">Action</b-dropdown-item>-->
<!--          <b-dropdown-item href="#">Another action</b-dropdown-item>-->
<!--          <b-dropdown-item href="#">Something else here</b-dropdown-item>-->
<!--          <b-dropdown-divider></b-dropdown-divider>-->
<!--          <b-dropdown-item href="#">Separated link</b-dropdown-item>-->
<!--        </b-dropdown>-->
      </div>
      <div data-simplebar class="mt-2" style="max-height: 280px">
        <ul class="verti-timeline list-unstyled">

          <li class="event-list active">
            <div class="event-timeline-dot">
              <i
                class="bx bxs-right-arrow-circle font-size-18 bx-fade-right"
              ></i>
            </div>
            <div class="d-flex">
              <div class="me-3">
                <h5 class="font-size-14">
                  30 Mar
                  <i
                    class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"
                  ></i>
                </h5>
              </div>
              <div class="flex-grow-1">
                <div>
                  Elaboração
                  <span class="font-weight-semibold"
                    >Novo orçamento R$ 1.000.000,00</span
                  >
                  MG... <a href="#">Abrir</a>
                </div>
              </div>
            </div>
          </li>

          <li class="event-list">
            <div class="event-timeline-dot">
              <i class="bx bx-right-arrow-circle font-size-18"></i>
            </div>
            <div class="d-flex">
              <div class="me-3">
                <h5 class="font-size-14">
                  30 Mar
                  <i
                    class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"
                  ></i>
                </h5>
              </div>
              <div class="flex-grow-1">
                <div>
                  Novo orçamento R$ 850.000,00 ES
                  <a href="#">Abrir</a>
                </div>
              </div>
            </div>
          </li>

          <li class="event-list">
            <div class="event-timeline-dot">
              <i class="bx bx-right-arrow-circle font-size-18"></i>
            </div>
            <div class="d-flex">
              <div class="me-3">
                <h5 class="font-size-14">
                  30 Mar
                  <i
                    class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"
                  ></i>
                </h5>
              </div>
              <div class="flex-grow-1">
                <div>
                  RJ
                  <span class="font-weight-semibold"
                    >Conversão de Pedido R$ 54.820,00</span
                  >
                </div>
              </div>
            </div>
          </li>

          <li class="event-list">
            <div class="event-timeline-dot">
              <i class="bx bx-right-arrow-circle font-size-18"></i>
            </div>
            <div class="d-flex">
              <div class="me-3">
                <h5 class="font-size-14">
                  29 Mar
                  <i
                    class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"
                  ></i>
                </h5>
              </div>
              <div class="flex-grow-1">
                <div>
                  ES
                  <span class="font-weight-semibold"
                    >Conversão de Pedido R$ 854.411,00</span
                  >
                </div>
              </div>
            </div>
          </li>

          <li class="event-list">
            <div class="event-timeline-dot">
              <i class="bx bx-right-arrow-circle font-size-18"></i>
            </div>
            <div class="d-flex">
              <div class="me-3">
                <h5 class="font-size-14">
                  29 Mar
                  <i
                      class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"
                  ></i>
                </h5>
              </div>
              <div class="flex-grow-1">
                <div>
                  Novo orçamento R$ 47.544,00 ES
                  <a href="#">Abrir</a>
                </div>
              </div>
            </div>
          </li>



        </ul>
      </div>

      <div class="text-center mt-4">
        <router-link to="/orcamentos/list" class="btn btn-primary waves-effect waves-light btn-sm"
          >Mais detalhes <i class="mdi mdi-arrow-right ms-1"></i
        ></router-link>
      </div>
    </div>
  </div>
  <!-- end card -->
</template>
